import type { NodeVariant } from '@octopus-do/octopus-project-core'
import {
  FrameDashed,
  FrameGhost,
  FrameNeutral,
  FrameStack,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

// Key the menu reports to Toolbar.Root; the picked NodeVariant follows it.
export const FRAME_MENU_ID = 'frame'

export interface FrameOption {
  icon: React.FC<{ className?: string }>
  id: NodeVariant
  tooltip: string
}

export const FRAME_OPTIONS: FrameOption[] = [
  { icon: FrameNeutral, id: 'default', tooltip: 'Page' },
  { icon: FrameDashed, id: 'frame', tooltip: 'Dashed' },
  { icon: FrameGhost, id: 'ghost', tooltip: 'Ghost' },
  { icon: FrameStack, id: 'stack', tooltip: 'Stack' },
]
